<template>
  <header>
    <BNavbar v-b-color-mode="'dark'" toggleable="lg" variant="secondary">
        <BNavbarBrand href="#">FD Thing</BNavbarBrand>
<!--        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">-->
<!--          <span class="navbar-toggler-icon"></span>-->
<!--        </button>-->
        <BNavbarToggle target="navbarCollapse" />
        <BCollapse id="navbarCollapse" is-nav>
          <ul v-if="isLoggedIn" class="navbar-nav me-auto mb-2 mb-md-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/postCall">Post Call</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/burn">Burn Restrictions</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/calls/grid">All Calls</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/profile">My Profile</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="logout">Log Out</a>
            </li>
          </ul>
          <ul v-else class="navbar-nav me-auto mb-2 mb-md-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/burn">Burn Restrictions</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/register">Register</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/login">Log In</router-link>
            </li>
          </ul>
        </BCollapse>
    </BNavbar>
  </header>
</template>

<script>
import { defineComponent } from 'vue';
import { BNavbarToggle, BCollapse, BNavbar, BNavbarBrand } from 'bootstrap-vue-next';

export default defineComponent({
  name: 'NavBar',
  components: {BNavbarToggle, BCollapse, BNavbar, BNavbarBrand},
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('logOut');
      this.$router.push('/login');
    }
  },
});
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
